import { Branch } from '../base/branch';
import { Node } from '../base/node';
import { Prototype } from '../tree/prototype';
import { Folder } from './genus';
import { Genus } from './genus';
import { PublishData } from './publish-data';

export class Content extends Node {
    static _type: string = 'Content';

    prototypeId?: string;
    prototype?: Prototype;
    data?: any;
    publish?: PublishData;
    siteId?: string;

    constructor(source?: any) {
        super(source);

        if (source) {
            this.prototypeId = source.prototypeId;
            this.data = source.data;
            this.publish = source.publish ? new PublishData(source.publish) : undefined;
            this.siteId = source.siteId;
        }
    }

    copy(source?: any) {
        super.copy(source);

        if (source) {
            this.prototypeId = source.prototypeId;
            this.data = source.data;
            this.publish = source.publish ? new PublishData(source.publish) : undefined;
            this.siteId = source.siteId;
        }
    }

    get model(): any {
        const { prototype, ...rest } = super.model;
        return rest;
    }

    resetStatus(): any {
        this.isDirty = !!this.original?.length && this.original !== this.name;
    }

    override load(source?: any): void {
        this.copy(source);

        if (source) {
            this.prototype = new Prototype(source.prototype);
            this.prototype.load();
        }
    }

    override fit(branch: Branch): boolean {
        return branch instanceof Folder && this.fitFolder(branch) || branch instanceof Genus && !(branch instanceof Folder) && this.fitGenus(branch);
    }

    private fitGenus(genus: Genus): boolean {
        return this.prototypeId === genus.prototypeId
            && this.siteId === genus.siteId;
    }

    private fitFolder(folder: Folder): boolean {
        return this.prototypeId === folder.prototypeId
        && this.siteId === folder.siteId
        && (<Folder>this.parent).fitParent(folder);
    }
}
